import * as v from 'valibot'

export const appEnvInputSchema = v.picklist(['development', 'production', 'staging', 'e2e', 'msw'])

export const appEnvSchema = v.picklist(['development', 'production', 'staging', 'e2e', 'msw'])

export type AppEnvInput = v.InferOutput<typeof appEnvInputSchema>
export type AppEnv = v.InferOutput<typeof appEnvSchema>

export const optionalStringSchema = v.optional(v.pipe(v.string(), v.trim(), v.minLength(1)))
export const booleanFlagSchema = v.pipe(
  v.optional(v.picklist(['true', 'false']), 'false'),
  v.transform(value => value === 'true')
)

export function resolveAppEnv(value?: string): AppEnv {
  const fallback = process.env.NODE_ENV === 'production' ? 'production' : 'development'
  return v.parse(appEnvSchema, v.parse(appEnvInputSchema, value ?? fallback))
}
